module.exports = __webpack_public_path__ + "img/sdworker.788fdc84.png";